import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import useFetchViewCount from '../hooks/useFetchViewCount';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function IssuesViewTab({
  view
}) {
  const {
    count
  } = useFetchViewCount(view);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [count === 0 ? /*#__PURE__*/_jsx(StatusDot, {
      use: "error",
      marginInlineEnd: "100"
    }) : /*#__PURE__*/_jsx(Badge, {
      use: "count",
      marginInlineEnd: "100",
      children: count
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.sendStates.issues"
    })]
  });
}